import React, { Component } from "react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { updateUser, setUserUpdateState } from "../../../../../actions/userActions";
import UserEditForm from "./UserEditForm";
import { Button, Icon } from "@material-ui/core";
import TitledForm from "../../../../Helpers/TitledForm";
import FormView from "../../../../FormView";
import Title from "../../../../SidePanel/Title";
import LinkHelper from "../../../../Helpers/Link";
import { isEqual } from "lodash";
import { requestState } from "../../../../../actions/utils";
import { Redirect } from "react-router-dom";
import { validateUserEditor } from "../../../../../actions/validation";

const formName = "userEdit";
class UserEditor extends Component {

    constructor( props ) {
        super( props );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.translateValues = this.translateValues.bind( this );
        this.handleChange = this.handleChange.bind( this );
        this.setValidity = this.setValidity.bind( this );
        this.state = {
            validity: undefined
        }
    }

    setValidity( values ) {
        const validity = validateUserEditor( values, this.props.landlord );
        this.setState({
            validity
        });
    }

    isValid( validity ) {
        return validity !== undefined && !Object.keys( validity ).length;
    }

    handleChange( values, dispatch, props, previousValues ) {
        this.setValidity( values );
        if ( this.props.onChange )
            this.props.onChange( values, dispatch, props, previousValues );
    }

    handleSubmit( values, dispatch, props ) {
        const translatedValues = this.translateValues( values );
        Object.keys( translatedValues ).forEach( key => {
            if ( isEqual( translatedValues[key], this.props.user[key] ) ) {
                delete translatedValues[key];
            }
        } );
        console.log( "NEW VALUES >>", translatedValues ); // DEBUG
        this.props.updateUser( translatedValues );
    }

    initialOccupation( occupation ) {
        if ( !occupation )
            return {};
        const result = {};
        result.occupation = [];
        if ( occupation.work ) {
            result.occupation.push( "work" );
            if ( occupation.workDetails )
                result.workDetails = occupation.workDetails;
        }
        if ( occupation.student ) {
            result.occupation.push( "student" );
            if ( occupation.studentDetails )
                result.studentDetails = occupation.studentDetails;
        }
        return result;
    }

    translateOccupation( occupation, workDetails, studentDetails ) {
        if ( !occupation )
            return {};
        if ( occupation.length === 0 )
            return {};
        const result = {};
        if ( occupation.includes( "work" ) ) {
            result.work = true;
            if ( workDetails )
                result.workDetails = workDetails;
        }
        if ( occupation.includes( "student" ) ) {
            result.student = true;
            if ( studentDetails )
                result.studentDetails = studentDetails;
        }
        return result;
    }

    translateEmployee( employee ) {
        if ( !employee && employee !== 0 )
            return undefined;
        return Number( employee );
    }

    initialValues( values ) {
        return {
            ...values,
            ...this.initialOccupation( values.occupation )
        }
    }

    translateValues( values ) {
        const trimmedValues = {};
        Object.keys( values ).forEach( key => {
            if ( this.props.user.hasOwnProperty( key ) ) {
                trimmedValues[key] = values[key];
            }
        } );
        return {
            ...trimmedValues,
            occupation: this.translateOccupation( values.occupation, values.workDetails, values.studentDetails ),
            employee: this.translateEmployee( values.employee )
        }
    }

    render() {
        const { user, manualSubmit, submitState, dispatch } = this.props;
        if ( submitState === requestState.ok ) {
            dispatch( setUserUpdateState( requestState.none ) );
            return <Redirect to="/user/information"/>
        }
        return (
            <FormView
                content={
                    <TitledForm 
                        stretch 
                        titleAlign="left"
                        titleSize="wide"
                        formSize="wide"
                        formAlign="stretch"
                        title="Here you can edit your user profile"
                        form={
                            <UserEditForm
                                validity={this.state.validity}
                                form={formName}
                                onChange={this.handleChange}
                                onSubmit={this.handleSubmit}
                                initialValues={this.initialValues( user )}
                            />
                        }
                        header={
                            <LinkHelper to="/user/information">
                                <Button
                                    color="secondary"
                                >
                                    <Icon>arrow_back</Icon>&nbsp;Go back to the previous page
                                </Button>
                            </LinkHelper>
                        }
                        footer={
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={!this.isValid( this.state.validity )}
                                onClick={() => manualSubmit( formName )}
                            >
                                Submit
                            </Button>
                        }
                    />
                }
                sideContent={<Title/>}
            />
        );
    }

}

export default connect(
    state => ({
        user: state.user.data,
        landlord: state.user.data.isLandlord,
        submitState: state.user.updateState
    }),
    dispatch => ({
        manualSubmit: ( form ) => dispatch( submit( form ) ),
        updateUser: ( values ) => dispatch( updateUser( values ) ),
        dispatch: dispatch
    })
)( UserEditor );